export const getProductId = (productIdWithPrefix: string): string => {
	if (!productIdWithPrefix) {
		return '';
	}
	return productIdWithPrefix.substring(
		productIdWithPrefix.indexOf('_') !== -1 ? productIdWithPrefix.indexOf('_') + 1 : 0,
		productIdWithPrefix.length
	);
};
